/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {ModalEl, ModalType} from 'common/components/modal';
import {InputEl} from 'common/components/input';
import {ButtonEl} from 'common/components/button';
import type {NpsSurvey} from 'common/widgets/nps-survey/index';
import {ButtonTheme} from 'common/components/button/constants';

export function template(this: NpsSurvey) {
  const {open, responseText, score, submittedScore, surveyId} = this.state;

  return (
    <ModalEl
      sel='.nps-survey-root'
      class={{
        'nps-survey-score-screen': !submittedScore,
        'nps-survey-text-screen': submittedScore,
      }}
      attrs={{
        closeable: true,
        'modal-type': ModalType.Popup,
        'not-fullscreen': true,
        open,
      }}
      on={{change: this.helpers.handleModalChange}}
    >
      <div
        sel='.nps-survey-content'
        class={{
          'nps-survey-score-screen': !submittedScore,
          'nps-survey-text-screen': submittedScore,
        }}
      >
        {!submittedScore ? (
          <>
            <div sel='.nps-survey-header'>{this.t(`nps-survey.question`)}</div>
            <div sel='.nps-survey-scores'>
              {this.helpers.getScores().map((option) => (
                <div
                  sel='.nps-survey-score-button'
                  on={{
                    click: () => this.helpers.handleClickScore(option),
                  }}
                >
                  {option}
                </div>
              ))}
            </div>
            <div sel='.nps-survey-likeliness'>
              <span>{this.t(`nps-survey.not-at-all-likely`)}</span>
              <span>{this.t(`nps-survey.extremely-likely`)}</span>
            </div>
          </>
        ) : (
          <>
            <div sel='.nps-survey-header'>{this.t(`nps-survey.thank-you`)}</div>
            <div sel='.nps-survey-question'>
              <span sel='.nps-survey-text'>{this.t(`nps-survey.why-did-you-rate`, {score})}</span>
            </div>
            <div sel='.nps-survey-response-text-container'>
              <InputEl
                sel='.nps-survey-response-text'
                params={{
                  type: `textarea`,
                  autoFocus: true,
                  onInput: this.helpers.handleTextInput,
                }}
                props={{
                  value: responseText,
                }}
              />
            </div>
            <div sel='.nps-survey-button-container'>
              <ButtonEl sel='.nps-survey-dismiss-button' on={{click: this.helpers.handleClickDismiss}}>
                {this.t(`nps-survey.dismiss`)}
              </ButtonEl>
              <ButtonEl
                sel='.nps-survey-submit-button'
                attrs={{
                  theme: ButtonTheme.Primary,
                  disabled: !Number.isInteger(surveyId),
                }}
                on={{click: this.helpers.handleClickSubmit}}
              >
                {this.t(`nps-survey.submit`)}
              </ButtonEl>
            </div>
          </>
        )}
      </div>
    </ModalEl>
  );
}
